import LayoutWithSidebar from "../components/LayoutWithSidebar";
import RegisterSideMenu from "../components/RegisterSideMenu";
import MainHeaderContainer from "../containers/MainHeaderContainer";
import AddPermitContainer from "../containers/AddPermitContainer";
import { Grid, GridColumn } from "semantic-ui-react";

const AddPermitPage = () => {
  const headerContent = () => {
    return <MainHeaderContainer></MainHeaderContainer>;
  };

  const sidebarContent = () => {
    return (
      <Grid>
        <Grid.Row>
          <GridColumn only="mobile">
            <RegisterSideMenu iconOnly={true}></RegisterSideMenu>
          </GridColumn>
          <GridColumn only="tablet computer">
            <RegisterSideMenu iconOnly={false}></RegisterSideMenu>
          </GridColumn>
        </Grid.Row>
      </Grid>
    );
  };

  const contentPanelContent = () => {
    return <AddPermitContainer></AddPermitContainer>;
  };

  return (
    <LayoutWithSidebar
      headerContent={headerContent()}
      sidebarContent={sidebarContent()}
      mainPanelContent={contentPanelContent()}
    ></LayoutWithSidebar>
  );
};

export default AddPermitPage;
